import { CheckCircle } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface ProgressCardProps {
  completion: number;
}

export function ProgressCard({ completion }: ProgressCardProps) {
  return (
    <div className="wizard-card border border-slate-100">
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <CheckCircle className="h-5 w-5 shrink-0 text-primary" strokeWidth={2} />
            <span className="text-base font-semibold leading-6 text-slate-900">
              {"Section Completion"}
            </span>
          </div>
          <span className="text-sm font-bold leading-5 text-slate-500">{completion}%</span>
        </div>
        <Progress value={completion} className="h-2.5 bg-slate-200" />
        <p className="text-sm leading-5 text-slate-500">
          {`Completion: ${completion}%`}
        </p>
      </div>
    </div>
  );
}
